import { ApolloProvider } from '@apollo/client'
import { openIntercom, Posthog, useApolloClient } from '@salescore/client-base'
import { useLocation } from '@tanstack/react-router'
import { Layout } from 'antd'
import { isNotNullish } from 'effect/Predicate'
import { type ReactElement, useEffect } from 'react'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { useTitle } from 'react-use'

import { ErrorProvider } from '../providers/ErrorProvider.tsx'
import { I18nProviderWithNoAuth } from '../providers/I18nProvider'

const NotAuthenticatedApolloProvider = ({ children }: { children: ReactElement }): ReactElement => {
  const client = useApolloClient()

  if (client === undefined) {
    return <></>
  }

  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

const prefix = process.env.APP_ENV === 'prod' ? undefined : `[${process.env.APP_ENV}]`

const Body = ({ children }: { children: ReactElement }): ReactElement => {
  useTitle([prefix, 'SALESCORE'].filter(isNotNullish).join(' | '))
  const location = useLocation()
  useEffect(() => {
    openIntercom({})
  }, [])
  useEffect(() => {
    Posthog.trackAccess(location.pathname, {})
  }, [location.pathname])
  return (
    <I18nProviderWithNoAuth>
      <ErrorProvider>
        <Layout className="h-full bg-gray-900">
          <SwitchTransition>
            <CSSTransition key={location.pathname} timeout={200} classNames="page-transition">
              {children}
            </CSSTransition>
          </SwitchTransition>
        </Layout>
      </ErrorProvider>
    </I18nProviderWithNoAuth>
  )
}

export const NoMemberLayout = ({ children }: { children: ReactElement }): ReactElement => (
  <NotAuthenticatedApolloProvider>
    <Body>{children}</Body>
  </NotAuthenticatedApolloProvider>
)
